import { render, staticRenderFns } from "./OrnamentOpen.vue?vue&type=template&id=02220924&scoped=true&"
import script from "./OrnamentOpen.vue?vue&type=script&lang=js&"
export * from "./OrnamentOpen.vue?vue&type=script&lang=js&"
import style0 from "./OrnamentOpen.vue?vue&type=style&index=0&id=02220924&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02220924",
  null
  
)

export default component.exports